import { render, staticRenderFns } from "./RChip.vue?vue&type=template&id=0648afaf&scoped=true&"
import script from "./RChip.vue?vue&type=script&lang=js&"
export * from "./RChip.vue?vue&type=script&lang=js&"
import style0 from "./RChip.vue?vue&type=style&index=0&id=0648afaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0648afaf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
